import { cva } from 'class-variance-authority';

export const badgeSelectStyles = cva('px-2 py-1 font-inter text-body-regular border rounded-md transition-colors cursor-pointer select-none focus:outline-none', {
  variants: {
    type: {
      default: 'bg-white',
      secondary: '',
    },
    active: {
      true: 'border-blue-300 text-blue-700',
      false: 'border-grey-300 text-grey-700 hover:border-grey-400',
    },
  },
  defaultVariants: {
    type: 'default',
  },
  compoundVariants: [
    {
      type: 'default',
      active: true,
      className: 'bg-white border-blue-300 text-blue-700',
    },
    {
      type: 'default',
      active: false,
      className: 'bg-white border-grey-300 text-grey-700 hover:border-grey-400',
    },
    {
      type: 'secondary',
      active: true,
      className: 'bg-blue-50 border-blue-300 text-blue-700',
    },
    {
      type: 'secondary',
      active: false,
      className: 'bg-grey-100 border-grey-300 text-grey-700 hover:border-grey-400',
    },
  ],
});